import shouldRedirectToProfiler from './shouldRedirectToProfiler';
import { getAxiosClient } from '~src/api';
// import { notifyUser } from '~src/utils';
import { modifyState } from '~src/state';
import browserLocalstorage from 'browser-localstorage-expire';
import editorConfig from '~config/editorConfig';

const localCache = browserLocalstorage();

export const getUser = async (payload = {}, ignoreCache = false) => {
  payload.requestHubspotToken = true;
  payload.requestJiraToken = false;
  let startupResponse;
  if (ignoreCache) {
    localStorage.removeItem('startup');
    localStorage.removeItem('disabledFeatures');
    // No longer used: user feature cache handled in features.js
  }
  const cachedStartup = localCache.getItem('startup');
  if (cachedStartup) {
    try {
      startupResponse = cachedStartup;
    } catch (error) {
      console.error('Cannot JSON decode cached startup response');
    }
  }

  if (!startupResponse) {
    try {
      const httpClient = await getAxiosClient();
      const userResponse = await httpClient.post(
        `${process.env.USER_API_URL}/startup`,
        payload
      );
      startupResponse = userResponse.data;
      modifyState('user', userResponse.data.user);
      localCache.setItem(
        'startup',
        userResponse.data,
        editorConfig.localStorageExpiryInMinutes
      );
    } catch (error) {
      console.error('Error in User API', error);
    }
  }

  return startupResponse;
};

export const isLoggedUserGlobalEditor = async () => {
  const { user } = await getUser();

  return user && user.giottoGlobalAdmin === true;
};

export const isUserAuthorized = async () => {
  // const { user } = await getUser();
  // if (user.org_pointer.tipo_licenza === 'plus') {
  //   await notifyUser();
  // }
};

export { shouldRedirectToProfiler };
